<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="getTitle">
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="12" right>
              <div class="d-flex align-center">
                <v-text-field
                  :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                  v-model="search"
                  append-icon="mdi-magnify"
                  class="ml-auto mb-2"
                  label="Search"
                  hide-details
                  single-line
                  style="max-width:350px;"
                  @input="searchHandler()"
                />
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit" @click="modalOpen">
                    <v-icon left>mdi-plus</v-icon>
                    ADD SECTION
                  </v-btn>
                </v-card-actions>
              </div>
            </v-col>
          </v-row>
          <v-dialog
            v-model="addModal"
            persistent
            width="500"
            :active="addModal"
            :on-cancel="
              () => {
                addModal = false
              }
            "
          >
            <form action="modal-card-body" @submit.prevent="addFolder">
              <v-card>
                <v-toolbar dark color="darkblue">
                  <v-toolbar-title>Add Section </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <label class="label">Section Name</label>
                  <v-text-field label="Enter Section Name" v-model.trim="foldername" pattern="[a-zA-Z\s]+"> </v-text-field>
                </v-card-text>
                <v-card-text>
                  <div class="field pb-0 mb-0">
                    <label class="font-weight-medium body-2">
                      Access Level
                    </label>
                    <v-checkbox v-model="flag" @change="allAccess" label="Select All"></v-checkbox>
                    <multiselect
                      class="overflowmultiselect2"
                      label="roleName"
                      track-by="roleName"
                      @input="selectedRoles"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="roles"
                      v-model="selectedRoles"
                      ><template slot="selection" slot-scope="{ values, isOpen }"
                        ><span class="multiselect__single" v-if="values.role && !isOpen">{{ values.roleName }} </span></template
                      >
                    </multiselect>
                  </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <!-- <v-btn class="button" @click="addModal = false">Cancel</v-btn> -->
                  <v-btn
                    @click="
                      () => {
                        ;(addModal = false), (foldername = ''), (selectedRoles = '')
                      }
                    "
                  >
                    Cancel</v-btn
                  >
                  <span class="v-btn__content"><input type="submit" class="button" value="Save" color="primary"/></span>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>

          <v-card-title>
            SOPs Listing
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider class=" my-0 " />

          <v-data-table
            v-if="lists.length"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="lists"
            disable-pagination
            :hide-default-footer="true"
            item-key="srno"
          >
            <template v-slot:[`item.name`]="{ item }">
              <span class="text-capitalize">{{ item.name }} </span>
            </template>
            <template v-slot:[`item.roleName`]="{ item }">
              <span v-for="(section, index) in item.accessFolderLevel" :key="index">
                <div class="text-capitalize v-chip theme--light v-size--small grey lighten-3 role-items" v-if="section.accessLevel[0] ? section.accessLevel[0].roleName : false">
                  {{ section.accessLevel[0] ? section.accessLevel[0].roleName : '' }}
                </div>
              </span>
            </template>

            <template v-slot:[`item.files`]="{ item }">
              {{ item.files.length }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                class="px-2 ml-1 ma-1"
                color="success"
                min-width="0"
                small
                v-on:click="
                  () => {
                    $router.push({ name: 'editSopSection', params: { id: item.id } })
                  }
                "
              >
                <v-icon small> mdi-notebook-edit-outline </v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          <!--Pagination start-->
          <v-row>
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages" @input="handlePageChange"> </v-pagination>
            </v-col>
          </v-row>
          <!--Pagination end-->
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Multiselect from 'vue-multiselect'
// import moment from 'moment'

// import _ from 'lodash'

export default {
  name: 'addRoles',
  components: {
    MaterialCard,
    Multiselect
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      getTitle: 'Manage Sops',
      roles: [],
      rolesList: [],
      lists: [],
      roleName: '',
      resultArray: [],
      loadingComponent: null,
      foldername: '',
      selectedRoles: [],
      userObj: {
        roleName: '',
        name: '',
        files: ''
      },
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      addModal: false,
      search: '',
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Section Name', value: 'name', sortable: true },
        { text: 'Access Level', value: 'roleName', sortable: true },
        { text: 'No. of Files', value: 'files', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      flag: ''
    }
  },

  async created () {
    await this.getSopData()
    await this.getRoleList()
  },
  beforeDestroy () {
    let elements = document.getElementsByClassName('vuedl-layout__closeBtn')
    if (elements.length > 0) {
      elements[0].click()
    }
  },
  methods: {
    getSopData: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/sop-module/allsops`, {
          params: {
            page: this.page - 1,
            size: this.pageSize,
            search: this.search
          }
        })
        // console.log(res, 'testing2')
        this.lists = res.data.rows.map((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
          return item
        })
        // console.log(this.lists, 'testshgh')
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getRoleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/sop-module/allroles`)
        // console.log(res, 'testingItem1')
        this.roles = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    addFolder: async function () {
      let formData = {}
      formData.name = this.foldername

      formData.isActive = true
      formData.accessibleTo = this.selectedRoles.map(item => {
        return {
          sopAccessID: item.id
        }
      })
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let res = await http.post(`${constants.API_URL}/api/sop-module/createfolder`, formData)
        // console.log(res)
        if (res.data === 'Folder Already Exist.') {
          this.errMsg(res.data)
        } else {
          this.okMsg(res.data)
        }
        this.addModal = false
        // this.folderName = ''
        this.loadingComponent.close()

        this.getSopData()
        this.foldername = ''
        this.selectedRoles = ''
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    handlePageChange: function () {
      // console.log(`Page: ${this.page}`)
      this.getSopData()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getSopData()
    },
    modalOpen (mode) {
      this.addModal = true
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg,
        duration: 4000
      })
    },
    searchHandler: function () {
      if (this.search.length > 3) {
        this.getSopData()
      }
    },
    key: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault()
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error',
        duration: 4000
      })
    },
    allAccess: function () {
      let accessArray = []
      if (this.flag === true) {
        this.roles.forEach(Obj => {
          accessArray.push(Obj)
        })
        this.flag = true
      }
      this.selectedRoles = accessArray
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.role-items {
  margin: 5px;
}
</style>
